import { Reveal } from '@/components/Reveal/Reveal';
import { Section } from '@/components/Section/Section';
import { StepIcon } from '@/components/StepIcon/StepIcon';
import { HOME_PROCESS, PROCESS_STEPS } from '@/dictionary/home';
import { HOME_ANCHORS } from '@/dictionary/routes';
import processBackgroundUrl from '/assets/who-bg.mp4';
import classes from './ProcessSection.module.css';

/* וידאו הרקע הוא who-bg.mp4 — כך במקור, למרות שם הקובץ. */
export function ProcessSection() {
  return (
    <Section
      id={HOME_ANCHORS.process.slice(1)}
      backgroundVideoUrl={processBackgroundUrl}
      veilOpacity={0.58}
      videoOpacity={0.75}
    >
      <Reveal>
        <div className={classes.head}>
          <p className={classes.kicker}>{HOME_PROCESS.kicker}</p>
          <h2 className={classes.title}>
            {HOME_PROCESS.titleLead}
            <br />
            <span className={classes.thin}>{HOME_PROCESS.titleThin}</span>
          </h2>
          <p className={classes.lead}>{HOME_PROCESS.lead}</p>
        </div>
      </Reveal>

      <div className={classes.steps}>
        <div className={classes.rail} />
        <div className={classes.railFlag}>
          <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M6 22V3" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
            <path
              d="M6 3.5h12.5l-3 4.5 3 4.5H6z"
              fill="#fff"
              stroke="#fff"
              strokeWidth="1.2"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <span className={`${classes.railCap} ${classes.railCapStart}`}>
          {HOME_PROCESS.railStart}
        </span>
        <span className={`${classes.railCap} ${classes.railCapEnd}`}>{HOME_PROCESS.railEnd}</span>

        {PROCESS_STEPS.map((step) => (
          <div key={step.icon} className={classes.step} tabIndex={0}>
            <div className={classes.stepIcon}>
              <StepIcon name={step.icon} />
            </div>
            <h3 className={classes.stepTitle}>
              {step.titleLines.map((line) => (
                <span key={line}>{line}</span>
              ))}
            </h3>
            <p className={classes.stepDescription}>{step.description}</p>
          </div>
        ))}
      </div>
    </Section>
  );
}
